/**
 * @file Data zoom model
 */


    var DataZoomModel = require('./DataZoomModel');

    module.exports = DataZoomModel.extend({

        type: 'dataZoom.select'

    });




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/dataZoom/SelectZoomModel.js
// module id = 1233
// module chunks = 158